import { useMemo } from 'react'
import { alpha } from '@mui/material/styles'

export const useKeyPhrasesStyles = () => {
  return useMemo(
    () => ({
      headerBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 1,
        py: 0.5,
      },
      titleBox: {
        display: 'flex',
        alignItems: 'center',
      },
      chip: {
        ml: 1,
        height: 20,
        bgcolor: 'grey.300',
      },
      list: {
        maxHeight: '300px',
        overflow: 'auto',
      },
      listItem: {
        bgcolor: 'grey.100',
        borderRadius: 1,
        mb: 0.85,
        height: '2.75rem',
        display: 'flex',
        justifyContent: 'space-between',
      },
      pendingDeleteItem: {
        bgcolor: 'grey.300',
      },
      alert: {
        mb: 2,
        display: 'flex',
        alignItems: 'center',
      },
      alertActions: {
        display: 'flex',
        gap: 1,
      },
      quoteIcon: {
        color: 'grey.400',
        fontSize: '1rem',
      },
      emptyBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
      },
      emptyIcon: { color: 'grey.500' },
    }),
    [],
  )
}

export const useMoveToThemeStyles = () => {
  return useMemo(
    () => ({
      breadcrumbsContainer: {
        mb: 0.85,
        pt: 1,
      },
      backLink: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      },
      searchBox: {
        my: 1.5,
      },
      destinationHeader: {
        display: 'flex',
        alignItems: 'center',
        py: 0.5,
      },
      chip: {
        ml: 1,
        height: 20,
        bgcolor: 'grey.300',
      },
      list: {
        maxHeight: 300,
        overflow: 'auto',
      },
      listItem: {
        bgcolor: 'grey.100',
        borderRadius: 1,
        mb: 0.85,
        height: '2.75rem',
        cursor: 'pointer',
        border: '1.5px solid transparent',
        '&:hover': {
          borderColor: 'info.main',
        },
      },
      listItemIcon: {
        minWidth: '2rem',
      },
      listItemIconColor: {
        color: 'grey.400',
      },
      noMatchBox: {
        py: 4,
        textAlign: 'center',
      },
      noMatchIcon: {
        color: 'grey.500',
      },
    }),
    [],
  )
}

export const useThemeKeyPhrasesModalStyles = () => {
  return useMemo(
    () => ({
      dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      titleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      },
      iconColor: {
        color: 'grey.400',
      },
      dialogContent: {
        position: 'relative',
        minHeight: '300px',
      },
      backdrop: {
        position: 'absolute',
        zIndex: (theme: any) => theme.zIndex.drawer + 1,
        backgroundColor: alpha('#ffffff', 0.8),
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      },
    }),
    [],
  )
}

export const useThemesListStyles = () => {
  return useMemo(
    () => ({
      sectionBox: {
        mt: 2,
      },
      listItem: {
        bgcolor: 'background.paper',
        borderRadius: 1,
        mb: 2,
        height: '3.5rem',
        cursor: 'pointer',
        border: '1.5px solid transparent',
        '&:hover': {
          borderColor: 'info.main',
        },
      },
      deleteListItem: {
        borderColor: 'info.main',
      },
      headerText: {
        mb: 2,
      },
    }),
    [],
  )
}

export const useCommonStyles = () => {
  return useMemo(
    () => ({
      quoteIcon: {
        color: 'grey.400',
        fontSize: '1rem',
      },
      longText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    }),
    [],
  )
}
